<div class="btn-container" [class.fixed]="fixedBlock">
	<div class="btn-container__top gray-btn gray-btn--light" (click)="scrollTop()" [class.show]="showBlock">
		<div class="icon icon--arrow-top"></div>
	</div>
	<div class="btn-container__share" [class.active]="showShare" id="my-share">
		<div class="gray-btn">
			<div class="icon icon--telegram"></div>
		</div>
		<div class="gray-btn">
			<div class="icon icon--whatsapp"></div>
		</div>
		<div class="gray-btn">
			<div class="icon icon--vk"></div>
		</div>
		<div class="gray-btn">
			<div class="icon icon--twitter"></div>
		</div>
		<div class="gray-btn">
			<div class="icon icon--facebook"></div>
		</div>
	</div>
	<div class="gray-btn" (click)="toggleShareShow()">
		<div class="icon icon--share"></div>
	</div>
</div>
